export default __webpack_public_path__ + "static/media/rajalakshmi.38d7cefa.jpg";